<div class="container">	
    <!-- <pre>{JSON.stringify(applicationsList, undefined, 1)}</pre> -->
    <div class="row pt-5">
        <div class="col-md-12 text-center">
            <h1>Error 404</h1>
        </div>
    </div>
</div>

